import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { REPRESENTANTES_MODALIDES_COMERCIAIS } from '../../../domain/representante-modalidade-comercial.enum';

@Component({
    selector: 'sgt-representante-modalidade-comercial-multiselect',
    templateUrl: './representante-modalidade-comercial-multiselect.component.html',
    styleUrls: ['./representante-modalidade-comercial-multiselect.component.less']
})
export class RepresentanteModalidadeComercialMultiselectComponent implements OnInit {
    /** Modalidades selecionadas */
    @Input() modalidades: number[];
    /** Ao alterar a seleção das modalidades */
    @Output() modalidadesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = false;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Modalidades Comerciais';
    @Input() checked = 'Modalidade'
    @Input() checkedPlural = 'Modalidades';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma modalidade encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-representante-modalidade-comercial ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as options para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        REPRESENTANTES_MODALIDES_COMERCIAIS?.forEach(modalidade => {
            selects.push({
                id: modalidade.id,
                name: modalidade.nome,
                classes: 'multiselect-item-representante-modalidade-comercial'
            });
        });

        this.options = selects;
    }

    /** Ao alterar a seleção das modalidades */
    onChange() {
        this.modalidadesChange.emit(this.modalidades);
    }
}
